/* Lazy video loader.
 * Defers <video data-lazy-video> downloads — the actual video bytes only
 * fetch once the element scrolls into view (or on DOMContentLoaded for
 * elements already in the viewport, like the hero). The poster image
 * shows immediately so first paint is unaffected. */
(function () {
  'use strict';

  function activateVideo(video) {
    if (video.dataset.lazyLoaded === '1') return;
    video.dataset.lazyLoaded = '1';

    var sources = video.querySelectorAll('source[data-src]');
    sources.forEach(function (s) {
      if (s.dataset.src) {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      }
    });

    try { video.load(); } catch (e) {}

    if (video.dataset.lazyAutoplay === '1') {
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { /* autoplay blocked by browser policy — leave as poster */ });
      }
    }
  }

  function isHidden(el) {
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return true;
    var rect = el.getBoundingClientRect();
    return rect.width === 0 && rect.height === 0;
  }

  function init() {
    var videos = Array.prototype.slice.call(
      document.querySelectorAll('video[data-lazy-video]')
    );
    if (!videos.length) return;

    var visible = videos.filter(function (v) { return !isHidden(v); });
    if (!visible.length) {
      // None visible at this breakpoint — re-check after the next resize
      var rerun = function () { setTimeout(init, 100); };
      window.addEventListener('resize', rerun, { once: true });
      return;
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activateVideo(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '300px 0px' });
      visible.forEach(function (v) { io.observe(v); });
    } else {
      visible.forEach(activateVideo);
    }
  }

  // Run as soon as the DOM is parsed — not waiting for window.load,
  // which on heavy pages doesn't fire until 10–20s in.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections are hot-reloaded inside the theme editor.
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 50);
  });
})();
